import { __awaiter } from "tslib";
import { useDrag, useDrop } from 'react-dnd';
import { getBrowserInfo } from '../utils';
import { useCanvasInstance, useCommand, useOFlowModel } from './useModel';
import { useOflowContext } from '../container';
import { getElementCategory } from '../model/common';
import ReactDOM from 'react-dom';
import $ from 'jquery';
const DROP_NODE_TYPE = 'DROP_NODE_TYPE';
// drop
export const useDndDrop = () => {
    const canvasInstance = useCanvasInstance();
    const command = useCommand();
    const model = useOFlowModel();
    const [, dropRef] = useDrop({
        accept: [DROP_NODE_TYPE],
        drop: (item, monitor) => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            const { x, y } = monitor.getClientOffset();
            const [graphX, graphY] = canvasInstance === null || canvasInstance === void 0 ? void 0 : canvasInstance.terminal2canvas([x, y]);
            const category = getElementCategory(item);
            const ElementClass = category === 'NODE'
                ? model.nodeTypeMap[item.type]
                : category === 'GROUP'
                    ? model.groupTypeMap[item.type]
                    : null;
            const width = (item === null || item === void 0 ? void 0 : item.width) || ((_a = ElementClass === null || ElementClass === void 0 ? void 0 : ElementClass.defaultConfig) === null || _a === void 0 ? void 0 : _a.width);
            const height = (item === null || item === void 0 ? void 0 : item.height) || ((_b = ElementClass === null || ElementClass === void 0 ? void 0 : ElementClass.defaultConfig) === null || _b === void 0 ? void 0 : _b.height);
            const newElement = Object.assign(Object.assign({}, item), { left: graphX - width / 2, top: graphY - height / 2, id: model.generateOFlowCanvasNodeId() });
            if (category === 'NODE') {
                command.execute('ADD_NODE', { payload: newElement });
            }
            else if (category === 'GROUP') {
                command.execute('ADD_GROUP', { payload: newElement });
            }
        }),
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
            draggingNode: monitor.getItemType(),
        }),
    });
    return { dropRef };
};
// drag
export const useDndDrag = ({ dndElementConfig }) => {
    const { oFlowId } = useOflowContext();
    const canvasInstance = useCanvasInstance();
    const model = useOFlowModel();
    const category = getElementCategory(dndElementConfig);
    const [, dragRef, dragPreview] = useDrag(() => ({
        type: DROP_NODE_TYPE,
        item: dndElementConfig,
        collect: monitor => ({
            isDragging: monitor.isDragging(),
            handlerId: monitor.getHandlerId(),
        }),
    }));
    // 鼠标移入时，生成预览图片
    const genPreviewElement = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const dndPreviewElement = document.getElementById(`oflow-client--dnd-preview-${oFlowId}`);
        const zoom = (_a = canvasInstance === null || canvasInstance === void 0 ? void 0 : canvasInstance.getZoom) === null || _a === void 0 ? void 0 : _a.call(canvasInstance);
        const ElementClass = category === 'NODE'
            ? model.nodeTypeMap[dndElementConfig.type]
            : category === 'GROUP'
                ? model.groupTypeMap[dndElementConfig.type]
                : null;
        const nodeWidth = dndElementConfig.width || ElementClass.defaultConfig.width;
        const nodeHeight = dndElementConfig.height || ElementClass.defaultConfig.height;
        const zoomWidth = nodeWidth * zoom;
        const zoomHeight = nodeHeight * zoom;
        const browserInfo = getBrowserInfo();
        if (ElementClass) {
            const elementInstance = new ElementClass({
                config: Object.assign(Object.assign({}, dndElementConfig), { width: nodeWidth, height: nodeHeight, id: model.generateOFlowCanvasNodeId() }),
                model,
                canvasId: canvasInstance === null || canvasInstance === void 0 ? void 0 : canvasInstance.canvasId,
                isDndPreview: true,
            });
            const reactElement = elementInstance === null || elementInstance === void 0 ? void 0 : elementInstance.render();
            ReactDOM.render(reactElement, dndPreviewElement);
            setTimeout(() => {
                $(dndPreviewElement.children[0]).css({
                    transform: `scale(${zoom})`,
                    transformOrigin: 'left top',
                });
            }, 0);
        }
        dragPreview(dndPreviewElement, {
            offsetX: zoomWidth / 2,
            offsetY: zoomHeight / 2,
        });
    });
    return { genPreviewElement, dragRef };
};
//# sourceMappingURL=useDnd.js.map